'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Cell = require('./Cell');

var _Cell2 = _interopRequireDefault(_Cell);

var _utils = require('../utils');

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Grid component adapts its styles based on a few different props.
// Some props are not required such as direction and align. If these props are
// not passed then the component will not generate styles for flex-direction and align-items.
var Grid = _styledComponents2.default.div.withConfig({
  displayName: 'Grid'
})(['box-sizing:border-box;display:flex;flex-direction:', ';align-items:', ';flex-wrap:wrap;list-style:none;margin:', ';padding:0;&:last-child{margin-bottom:0;}& ', '{', ';padding:', ';}'], function (props) {
  return props.direction;
}, function (props) {
  return _utils.align[props.align];
}, function (props) {
  return props.spacing ? '-' + props.spacing + ' 0 ' + props.spacing + ' -' + props.spacing : '-1em 0 1em -1em';
}, _Cell2.default, function (props) {
  return props.flexCells && 'display: flex;';
}, function (props) {
  return props.spacing ? props.spacing + ' 0 0 ' + props.spacing : '1em 0 0 1em';
});

Grid.propTypes = {
  flexCells: _propTypes.string,
  direction: _propTypes.string,
  align: _propTypes.string,
  spacing: _propTypes.string
};

exports.default = Grid;


//////////////////
// WEBPACK FOOTER
// ./~/flexomatic/lib/components/Grid.js
// module id = 799
// module chunks = 4